import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    apiSupportsTypeFlag: true,
    extendedAllowedAttachmentExtensions: ['rtf', 'zip', 'rar', 'dbf'],
};
